var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgFlex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1042,
    height: 851,
    viewBox: "0 0 1042 851",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_170_640)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 775.618,
    cy: 312.595,
    rx: 104.176,
    ry: 213.983,
    fill: "#FF4C00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_170_640)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 745.608,
    cy: 339.751,
    rx: 184.425,
    ry: 235.766,
    transform: "rotate(120 745.608 339.751)",
    fill: "#BD00FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_170_640)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.287,
    cy: 363.299,
    rx: 77.2967,
    ry: 178.329,
    transform: "rotate(30 723.287 363.299)",
    fill: "#00FF80"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_170_640)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 745.024,
    cy: 340.651,
    r: 125.861,
    fill: "#3849EB"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_170_640)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 745.117,
    cy: 340.281,
    r: 85.8747,
    fill: "#A5FBFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_170_640)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 745.182,
    cy: 340.651,
    r: 49.1965,
    fill: "#A5FBFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3201 333.995C106.428 322.119 117.155 292.138 105.278 267.03C93.4031 241.923 63.4218 231.196 38.3138 243.072C13.2067 254.948 2.48013 284.929 14.3554 310.036C26.2316 335.144 56.213 345.871 81.3201 333.995Z",
    fill: "url(#paint0_radial_170_640)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.41 496.154C233.975 472.632 331.324 531.846 354.846 628.411C378.367 724.975 319.155 822.325 222.59 845.846C126.025 869.368 28.6757 810.154 5.15408 713.59C-18.3676 617.025 40.8456 519.676 137.41 496.154Z",
    fill: "url(#paint1_radial_170_640)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.84 573.67C1001.11 600.37 961.03 603.581 934.33 580.844C907.631 558.106 904.418 518.03 927.156 491.33C949.894 464.631 989.97 461.418 1016.67 484.156C1043.37 506.894 1046.58 546.97 1023.84 573.67Z",
    fill: "url(#paint2_radial_170_640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_170_640",
    x: 598.208,
    y: 25.3778,
    width: 354.82,
    height: 574.434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.6171,
    result: "effect1_foregroundBlur_170_640"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_170_640",
    x: 380.738,
    y: 0.450485,
    width: 729.74,
    height: 678.601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70.3891,
    result: "effect1_foregroundBlur_170_640"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_170_640",
    x: 538.55,
    y: 130.828,
    width: 369.473,
    height: 464.943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.6171,
    result: "effect1_foregroundBlur_170_640"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_170_640",
    x: 564.237,
    y: 159.864,
    width: 361.573,
    height: 361.573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.4628,
    result: "effect1_foregroundBlur_170_640"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_170_640",
    x: 604.316,
    y: 199.48,
    width: 281.601,
    height: 281.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.4628,
    result: "effect1_foregroundBlur_170_640"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_170_640",
    x: 685,
    y: 280.469,
    width: 120.363,
    height: 120.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.49256,
    result: "effect1_foregroundBlur_170_640"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7589 283.851) rotate(14.976) scale(89.6374 103.549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#074F78",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25D28A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_170_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.6237 742.15) rotate(-31.7154) scale(325.861 298.567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827187,
    stopColor: "#2B0B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7484D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_170_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(933.983 497.763) rotate(38.56) scale(136.283 121.377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676226,
    stopColor: "#04001B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121745"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlex);
export default __webpack_public_path__ + "static/media/bgFlex.6a681dfb8c5a30450ebd30e45d8d4aa6.svg";
export { ForwardRef as ReactComponent };